import {fetchDataFromApi} from './apiHelper';

export const fetchStatisticFields = () => fetchDataFromApi('post', '/api/xml/pub-block-log/statistic');
export const fetchRemoteStatisticFields = () => fetchDataFromApi('post', '/api/xml/rem-block-log/statistic');